export default {
    infoData: {
        companyName: '',
        siteName: '',
        ledgerName: '',
        businessType: '',
        feeTaskType: '',
        noTaxAmount: '',
        amount: '',
        remark: '',
        taxAmount: '',
        supplierComfirmAmount: ''
    },
    tableDataItems: [
        {
            prop: 'feeName',
            label: '费用名称',
            type: 'normal'
        },
        {
            prop: 'volume',
            label: '体积(m³)',
            type: 'normal'
        },
        {
            prop: 'weight',
            label: '重量(kg)',
            type: 'normal'
        },
        {
            prop: 'quantity',
            label: '实际发货数量',
            type: 'normal'
        },
        {
            prop: 'businessTime',
            label: '计费日期',
            type: 'normal'
        },
        {
            prop: 'amount',
            label: '总费用',
            type: 'normal'
        },
        {
            prop: 'supplierAmount',
            label: '确认费用金额',
            type: 'normal'
        },
        {
            prop: 'supplierMsg',
            label: '备注',
            type: 'normal'
        },
        {
            prop: 'replyMsg',
            label: '安得回复',
            type: 'normal'
        }
    ],
    costTableDataItems: [
        {
            prop: 'feeNameCn',
            label: '费用名称',
            type: 'normal',
            width: '100'
        },
        {
            prop: 'customerNo',
            label: '客户订单号',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'subStr1',
            label: '快递单号',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'skuCode',
            label: '商品编码',
            width: '140',
            type: 'normal'
        },
        {
            prop: 'skuName',
            label: '商品名称',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'totalGrossWeight',
            label: '商品状态',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'toProvinceName',
            label: '买家省',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'toCityName',
            label: '买家市',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'toDistrictName',
            label: '买家区',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'userDefined11',
            label: '长',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'userDefined12',
            label: '宽',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'userDefined13',
            label: '高',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'volum',
            label: '体积(m³)',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'grossWeight',
            label: '重量(Kg)',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'quantity',
            label: '实发数量',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'price',
            label: '单价',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'fee',
            label: '不含税收入',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'taxrate',
            label: '税率',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'tax',
            label: '税额',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'amount',
            label: '含税收入',
            width: '150',
            type: 'normal'
        }
    ]
};
